import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { TOKEN } from '../../_helpers/token';
import { Link } from 'react-router-dom';
import * as moment from 'moment';

export class InvalidMessages extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [
            // {
            //     key: "id",
            //     TrOnlyClassName: 'tsc',
            //     text: "id",
            //     className: "tsc",
            //     align: "left"
            // },

            {
                key: "message",
                TrOnlyClassName: 'tsc',
                text: "Message",
                className: "tsc",
                align: "left"
            },


            {
                key: "action",
                text: "Handled",
                TrOnlyClassName: 'cell',
                className: "cell",
                width: 250,
                sortable: false,
                cell: record => {
                    return (
                        <div className="center" >
                            {record.handled === 1 ?
                                <span class="badge-success" style={{ borderRadius: "5px", padding: "2px" }}>
                                    YES
                                </span>
                                :
                                <>
                                    <span class="badge-danger" style={{ borderRadius: "5px", padding: "2px" }}>
                                        NO
                                    </span>
                                </>
                            }
                        </ div>
                    );
                }
            },

            {
                key: "dates2",
                TrOnlyClassName: 'tsc',
                text: "Time Created",
                className: "tsc",
                align: "left"
            },
            {
                key: "dates",
                TrOnlyClassName: 'tsc',
                text: "Time Handled",
                className: "tsc",
                align: "left"
            },
            {
                key: "action",
                text: "If Handled?",
                TrOnlyClassName: 'cell',
                className: "cell",
                width: 250,
                sortable: false,
                cell: record => {
                    return (
                        <div className="center" >
                            <button className=" btn-primary"
                                title="Remarks"
                                style={
                                    { marginRight: '10px' }}
                                onClick={
                                    () => {
                                        if (window.confirm('Have you handled this issue?'))
                                            this.onSubmitRemarkUpdate(record)
                                    }} >
                                <span className="" > Click here </span>
                            </button>

                        </div>
                    );
                }
            }


        ];
        this.config = {
            key_column: "tsc",
            length_menu: [10, 20, 50],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 10,

            show_length_menu: true,
            language: {
                loading_text: "Please be patient while data loads...",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
        };
    }


    componentDidMount() {
        this.getData();
    }


    onSubmitRemarkUpdate(record) {
        // e.preventDefault();
        this.setState({ isLoading4: true });
        let formData = {
            id: record.id
        }


        // alert(JSON.stringify(formData))
        this.setState({ isLoading4: true });
        axios.put(baseURL + 'updateInvalidMessage', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            alert("success!");

            window.scrollTo(0, 0)

            this.getData()

        }).catch((error) => {
            this.setState({ isLoading4: false });

            alert(JSON.stringify(error.response))
        })
    }


    getData = (queryString = "") => {
        this.setState({
            isLoading: true,
        })
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "Authorization": TOKEN
            }
        };
        let url = baseURL + "getInvalidMessages?mobile=" + localStorage.getItem("phone") + '&' + queryString


        // alert(url)
        axios.all([
            axios.get(url, axiosConfig),
        ]).then(axios.spread((branchResponse) => {
            this.setState({
                admins: branchResponse.data,
                isLoading: false,
            }, function () {

                var data = [];
                console.log("BUG", branchResponse)

                for (let i = 0; i < this.state.admins.length || 0; i++) {
                    let mail;
                    let mcredit;
                    let mbalance;
                    this.setState({
                        total: branchResponse.data[0].total_page,
                    })



                    let dates = { dates2: moment.utc(this.state.admins[i].time).format("DD-MMM-yyyy HH:mm:ss") };

                    let date = { dates: this.state.admins[i].time_handled ? moment.utc(this.state.admins[i].time_handled).format("DD-MMM-yyyy HH:mm:ss") : "Not yet" };

                    data.push(Object.assign(date, dates, this.state.admins[i]));
                    this.setState({
                        data: data
                    })
                    console.log("bugs", data);
                }

            }
            );
        }))

    }

    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(queryString);
    }
    render() {
        return (
            <div>
                <>
                    <Col md={12} lg={12} >
                        <Card>
                            <CardBody >
                                <div className="panel-body" >
                                    <div className="row">
                                        <div className="col-6">
                                            <h4>({localStorage.getItem("phone")}) Invalide Messages</h4><br /><p></p>
                                        </div>
                                        <div className="col-md-6">
                                            <Link to="/userdetail">
                                                <Button className="float-right"
                                                    color="primary" outline><i className="fa  fa-arrow-left"></i> Back</Button><br /> <br /><br />
                                            </Link>
                                            <br />
                                        </div>
                                    </div>
                                    {this.state.isShowError ?
                                        <div className="alert alert-success" > {this.state.statusMessage}
                                        </div> : null
                                    }
                                    <ReactDatatable
                                        config={this.config}
                                        records={this.state.data}
                                        columns={this.columns}
                                        dynamic={true}
                                        id="tsc"
                                        loading={this.state.isLoading}
                                        total_record={this.state.total}
                                        onChange={this.tableChangeHandler} />
                                </div>
                            </CardBody>

                        </Card>
                    </Col>
                </>
            </div>

        )
    }
}